<template>
  <div class="studio-template-card d-flex flex-column">
    <div class="template-image-container pointer" @click="$emit('click')">
      <img :src="template.image" class="img-fluid template-image" />
    </div>
    <div class="template-details-container d-flex flex-row flex-nowrap">
      <div v-if="selected" class="is-selected px-3">
        <i class="fa fa-check c-brand-color"></i>
      </div>
      <div class="px-3 flex-grow-1">
        <h3 class="template-name">{{ template.name }}</h3>
        <div class="template-description">{{ template.description }}</div>
      </div>
      <div class="menu d-flex pull-right px-3">
        <div
          class="d-flex flex-row flex-nowrap justify-content-between align-items-center pointer"
          @click.prevent="$emit('preview')"
        >
          <span class="mr-2">{{ $t('SETTINGS.LINK.PREVIEW') }}</span>
          <i class="fa fa-eye c-coral"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HMStudioTemplateCard',
  props: {
    template: {
      type: Object,
    },
    selected: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';

.studio-template-card {
  .template-image {
    transition: all 0.3s ease-in-out;
  }

  &:hover {
    .template-image {
      box-shadow: 0 12px 12px -6px $dark-gray;
      transform: translateY(-16px);
    }

    .template-name {
      color: $coral;
    }
  }

  .template-image {
    width: 100%;
    height: auto;
    object-fit: contain;
  }

  .menu {
    max-height: 2rem;
  }
}
</style>
